import React from 'react';
import UploadFile from 'components/srv/file/uploadFile';
import FileList from 'components/srv/file/fileList';
import UnitLoading from 'components/parts/loading/unitLoading';
import Message from 'components/parts/message';

/**
 * プログラムファイル一覧画面
 */
const SrvFiles = () => {
  return (
    <div className="col-10 pt-3 pb-3">
      <UnitLoading/>
      {/* ファイルアップロード */}
      <UploadFile/>
      <Message/>
      {/* プログラムファイル一覧 */}
      <FileList/>
    </div>
  );
};
export default SrvFiles;
